import React, { useMemo, useState } from "react";

import Button from "../../ui/Button";
import AuditOpportunityInsights from "./AuditOpportunityInsights";
import AuditVolumeIcpBarChart from "./AuditVolumeIcpBarChart";

const TABS = [
  {
    id: "industry",
    label: "Industry",
    dataKey: "by_industry",
  },
  {
    id: "role",
    label: "Role",
    dataKey: "by_role_title",
  },
  {
    id: "businessModel",
    label: "Business Model",
    dataKey: "by_business_model",
  },
  {
    id: "maturity",
    label: "Maturity",
    dataKey: "by_company_maturity",
  },
  {
    id: "salesMotion",
    label: "Sales Motion",
    dataKey: "by_sales_motion",
  },
  {
    id: "offerCategory",
    label: "Offer",
    dataKey: "by_offer_category",
  },
  {
    id: "geoFocus",
    label: "Geo",
    dataKey: "by_geo_focus",
  },
];

const MAX_BARS = 15;

export default function AuditSegmentExplorer({ auditData }) {
  const [tabId, setTabId] = useState("industry");

  const icpThreshold = auditData?.icp_threshold ?? null;

  const active = useMemo(() => TABS.find((t) => t.id === tabId) || TABS[0], [tabId]);

  const rawRows = auditData?.[active.dataKey];

  const description = `Cold inbound grouped by ${active.label.toLowerCase()}. Accent bars are ICP matches, muted bars are not matched.`;

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <Button
            key={t.id}
            type="button"
            size="sm"
            variant={t.id === tabId ? "primary" : "ghost"}
            onClick={() => setTabId(t.id)}
          >
            {t.label}
          </Button>
        ))}
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 items-start">
        <AuditVolumeIcpBarChart
          key={`${active.dataKey}-overview`}
          rows={rawRows}
          title={`${active.label} at a glance`}
          description={description}
          maxBars={MAX_BARS}
          icpThreshold={icpThreshold}
          emptyHint="No cold outreach rows for this dimension yet."
        />
        <AuditOpportunityInsights
          rows={rawRows}
          dimensionLabel={active.label}
        />
      </div>
    </div>
  );
}
